<template>

  <card>
    <template slot="header">
      <h4 class="card-title">{{ $t('moneyClaim.finalise.title') }}</h4>
    </template>
    <template>
      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>
      <div>
        <base-radio inline name="refunded" class="mb-3" v-model="formDetails.status">
          {{ $t('moneyClaim.finalise.refundRadioTitle') }}
        </base-radio>
        <base-radio inline name="canceled" class="mb-3" v-model="formDetails.status">
          {{ $t('moneyClaim.finalise.cancelRadioTitle') }}
        </base-radio>
      </div>
      <form @submit.prevent="validate()">
        <div v-if="formDetails.status === 'refunded'" class="row">
          <div class="col-md-4 col-lg-3 col-xl-2">
            <base-input :error="getError('refundedAt')" :label="$t('moneyClaim.finalise.refundedAtLabel')">
              <el-date-picker
                name="refundedAt"
                type="date"
                v-validate="modelValidations.required"
                v-model="formDetails.refunded_at"
                :placeholder="$t('moneyClaim.finalise.refundedAtPlaceholder')"
                :picker-options="pickerOptions">
              </el-date-picker>
            </base-input>
          </div>
        </div>
        <div v-if="formDetails.status === 'canceled'">
          <div class="row">
            <div class="col-md-4 col-lg-3 col-xl-2">
              <base-input :error="getError('cancel_reason')" :label="$t('moneyClaim.finalise.cancelReason')">
                <el-select
                  name="cancel_reason"
                  class="select-primary"
                  size="large"
                  v-validate="modelValidations.required"
                  v-model="formDetails.cancel_reason"
                  :error="getError('cancel_reason')">
                  <el-option
                    v-for="option in cancelReasons"
                    class="select-primary"
                    :value="option.value"
                    :label="$t(`moneyClaim.finalise.cancelReasons.${option.value}`)"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <base-input :label="$t('moneyClaim.finalise.cancelDescription')"
                          :error="getError('cancel_description')">
                <textarea class="form-control"
                          :placeholder="$t('moneyClaim.finalise.cancelDescriptionPlaceholder')"
                          name="cancel_description"
                          v-validate="modelValidations.required"
                          v-model="formDetails.cancel_description"
                          rows="2"></textarea>
              </base-input>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="row">
              <div class="col-6">
                <base-button class="w-100" native-type="submit" type="warning" :loading="updating">{{
                    formDetails.status ==
                    'refunded' ?
                      $t('moneyClaim.finalise.submitRefundedBtnTitle') : $t('moneyClaim.finalise.submitCanceledBtnTitle')
                  }}
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </card>
</template>
<script>
import {BaseAlert, BaseRadio} from 'src/components'
import {DatePicker, Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import swal from 'sweetalert2';

export default {
  name: 'finaliseMoneyClaim',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    BaseAlert,
    BaseRadio,
  },
  props: {
    moneyClaim: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      alert: false,
      formDetails: {
        refunded_at: null,
        status: 'refunded',
        cancel_reason: 'bad_bank_details',
        cancel_description: '',
      },
      modelValidations: {
        required: {
          required: true,
        },
      },
      cancelReasons: [{
        value: 'bad_bank_details',
        label: 'lbl_bad_bank_details'
      }, {
        value: 'input_mistake',
        label: 'lbl_input_mistake'
      }],

    };
  },
  computed: {
    ...mapState({
      updating: state => state.account_money_claim.updating,
      error: state => state.account_money_claim.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          return time.getTime() < this.minRefundDay || time.getTime() > Date.now();
        }
      }
    },
    minRefundDay: function () {
      return new Date(new Date(this.moneyClaim.created_at).toDateString())
    }
  },
  methods: {
    ...mapActions(['UpdateAccountMoneyClaim', 'LoadAccount', 'LoadAccountMoneyClaim', 'LoadAccountMoneyClaims']),

    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    confirmAlert(titleText, text) {
      swal({
        titleText: titleText,
        text: text,
        buttonsStyling: false,
        confirmButtonText: this.$t('moneyClaim.finalise.confirmAlert.actionBtnLabel'),
        cancelButtonText: this.$t('moneyClaim.finalise.confirmAlert.cancelBtnLabel'),
        confirmButtonClass: 'btn btn-warning',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.updateMoneyClaim();
        }
      })
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {

          let titleText = this.$t('moneyClaim.finalise.confirmAlert.refundedTitle')
          let text = ''
          switch (this.formDetails.status) {
            case 'canceled':
              titleText = this.$t('moneyClaim.finalise.confirmAlert.canceledTitle')
              text = this.$t('moneyClaim.finalise.cancelReasons.' + this.formDetails.cancel_reason)
              break
            default:
              text = this.$t('moneyClaim.finalise.confirmAlert.refundedText', {
                date: this.$options.filters.dateOnly(this.formDetails.refunded_at)
              })
          }
          this.confirmAlert(titleText, text)
        }
      });
    },
    updateMoneyClaim() {
      // Just refunded.
      this.UpdateAccountMoneyClaim({
        accountID: this.moneyClaim.account_id,
        moneyClaimID: this.moneyClaim.id,
        payload: this.formDetails,
      }).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.formDetails.status === 'refunded' ? this.$t('moneyClaim.finalise.closedNotification') : this.$t('moneyClaim.finalise.canceledNotification'),
            icon: 'tim-icons icon-alert-circle-exc'
          })

          this.LoadAccount(this.moneyClaim.account_id)
          // Refresh User money-claims
          this.LoadAccountMoneyClaim({
            accountID: this.moneyClaim.account_id,
            moneyClaimID: this.moneyClaim.id,
          })
          // Refresh User money-claims
          this.LoadAccountMoneyClaims(this.moneyClaim.account_id);
        }
      });
    }
  },
};
</script>
<style></style>
